// extracted by mini-css-extract-plugin
export default {"office-reviews-page__review-list":"mqMD_fCRLPovpzg4U9ZEQ","office-reviews-page__review":"lq3qJCDOeSOE3dfh0uM7Y"};